import React from "react";
import { Button, Dropdown, Tooltip } from "antd";
import { SettingOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";

/**
 * TableColumnConfig Component
 * Reusable dropdown button for table column configuration
 *
 * @param {Object} props
 * @param {Object} props.menu - Ant Design menu configuration object from useTableConfig
 * @param {string} props.buttonText - Text to display on button (optional, default: 'Columns')
 * @param {string} props.tooltipText - Tooltip text (optional, default: 'Configure Columns')
 * @param {string} props.placement - Dropdown placement (optional, default: 'bottomRight')
 * @param {string} props.size - Button size (optional, default: 'middle')
 * @param {boolean} props.showIcon - Show settings icon (optional, default: true)
 * @param {string} props.className - Additional CSS classes (optional)
 */
const TableColumnConfig = ({
  menu,
  buttonText = "",
  tooltipText = "Configure Columns",
  placement = "bottomRight",
  size = "middle",
  showIcon = true,
  className = "",
}) => {
  // Validation
  if (!menu || !menu.items || menu.items.length === 0) {
    console.warn("[TableColumnConfig] Invalid menu prop provided");
    return null;
  }

  return (
    <Dropdown
      menu={menu}
      trigger={["click"]}
      placement={placement}
      overlayStyle={{ maxHeight: '400px', overflowY: 'auto' }}
    >
      <Tooltip title={tooltipText} placement="bottom">
        <Button
          icon={showIcon ? <SettingOutlined /> : null}
          size={size}
          className={`hover:scale-105 transition-transform duration-200 ${className}`}
        >
          {buttonText}
        </Button>
      </Tooltip>
    </Dropdown>
  );
};

TableColumnConfig.propTypes = {
  menu: PropTypes.shape({
    items: PropTypes.array.isRequired,
  }).isRequired,
  buttonText: PropTypes.string,
  tooltipText: PropTypes.string,
  placement: PropTypes.oneOf([
    'top',
    'topLeft',
    'topRight',
    'bottom',
    'bottomLeft',
    'bottomRight',
    'left',
    'leftTop',
    'leftBottom',
    'right',
    'rightTop',
    'rightBottom',
  ]),
  size: PropTypes.oneOf(['small', 'middle', 'large']),
  showIcon: PropTypes.bool,
  className: PropTypes.string,
};

export default TableColumnConfig;
